import { useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader, Button, Label } from 'reactstrap';
import { Post, Discard } from 'Constant';
import { Btn, H5, H6, Spinner } from 'AbstractElements';
import MateriForm from 'Component/Learning/Materi/MateriForm';
import DropzoneCommon from 'Component/Learning/Common/Upload/Dropzone';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { submitMaterial } from 'Features/Learning/Materi/Utils/MateriUtils';
import { resetState, setField } from 'Features/Learning/Materi/addMaterialSlice';
import Swal from 'sweetalert2';
import ModalAddSubMateri from './ModalAddSubMateri';

const MateriPostContain = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const history = useNavigate();
  const data = useSelector(state => state.addMaterial)
  const [selectedValue, setSelectedValue] = useState([]);
  const [openSubMateri, setOpenSubMateri] = useState(false);
  const startUpload = useSelector(state => state.addMaterial.isLoading);
  const isUpdate = useSelector(state => state.addMaterial.isUpdate);

  useEffect(() => {
    id && dispatch(setField({ field: 'isUpdate', value: true }));
  }, [dispatch, id]);

  useEffect(() => {
    setSelectedValue(data.subMaterials);
  }, [data.subMaterials]);

  const handleSuccess = () => {
    dispatch(resetState());
    history(`${process.env.PUBLIC_URL}/learning/materi-list`);
  };

  const showError = (message) => {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: message,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let errorMessage = '';
    if (!isUpdate) {
      if (data.name === '' || data.description === '' || data.description === '<p><br></p>' || data.image === '' || data.image === null || data.subMaterials.length === 0) {
        if (data.name === '') {
          errorMessage = 'Nama Materi tidak boleh kosong.';
        } else if (data.description === '' || data.description === '<p><br></p>') {
          errorMessage = 'Deskripsi Materi tidak boleh kosong.';
        } else if (data.image === '' || data.image === null) {
          errorMessage = 'Banner Materi tidak boleh kosong.';
        } else if (data.subMaterials.length === 0) {
          errorMessage = 'Sub Materi belum dipilih.';
        }
        showError(errorMessage);
      } else {
        dispatch(submitMaterial({ ...data, successCallback: handleSuccess }))
      }
    } else {
      if (data.name === '' || data.description === '' || data.description === '<p><br></p>' || data.subMaterials.length === 0) {
        if (data.name === '') {
          errorMessage = 'Nama Materi tidak boleh kosong.';
        } else if (data.description === '' || data.description === '<p><br></p>') {
          errorMessage = 'Deskripsi Materi tidak boleh kosong.';
        } else if (data.subMaterials.length === 0) {
          errorMessage = 'Sub Materi belum dipilih.';
        }
        showError(errorMessage);
      } else {
        dispatch(submitMaterial({ ...data, successCallback: handleSuccess }))
      }
    }
  };

  const handleDiscard = (e) => {
    e.preventDefault();
    dispatch(resetState());
    history(`${process.env.PUBLIC_URL}/learning/materi-list`);
  };

  const handleSelectChange = (selectedOption) => {
    dispatch(setField({ field: 'subMaterials', value: selectedOption }));
  };

  const handleChangeStatus = ({ meta, file }, status) => {
    if (status === 'removed') {
      dispatch(setField({ field: 'image', value: '' }));
    } else if (status === 'done') {
      dispatch(setField({ field: 'image', value: file }));
    }
  };

  const handleOpenSubMateri = () => {
    setOpenSubMateri(!openSubMateri);
  };

  return (
    <Container fluid={true}>
      <Row>
        <Col sm="12">
          {startUpload ? (
            <Col lg="12">
              <div className="loader-box">
                <Spinner attrSpinner={{ className: 'loader-30' }} />
              </div>
              <H6 attrH6={{ className: 'sub-title mb-0 text-center' }}>{'Sedang proses unggah...'}</H6>
            </Col>
          ) : (
            <Card>
              <CardHeader className='pb-0'><H5>{isUpdate ? '' : 'Materi Baru'}</H5></CardHeader>
              <CardBody className="add-post">
                <MateriForm />
                <DropzoneCommon label={'Banner Materi'} inputContent={data.imageLink ? 'Ganti gambar...' : 'Silahkan upload gambar...'} handleChangeStatus={handleChangeStatus} accept="image/*" />
                <Label className="col-form-label" style={{ fontWeight: 'bold' }}>Sub Materi :</Label>
                <Button color={selectedValue.length > 0 ? 'success' : 'primary'} style={{ display: "block" }} onClick={handleOpenSubMateri}>{selectedValue.length > 0 ? "Edit" : 'Pilih'} Sub Materi ({selectedValue.length})</Button>
                <ModalAddSubMateri openSubMateri={openSubMateri} handleOpenSubMateri={handleOpenSubMateri} selectedValue={selectedValue} setSelectedValue={setSelectedValue} handleSelectChange={handleSelectChange} />
                <div className="btn-showcase text-end">
                  <Btn attrBtn={{ color: 'primary', type: 'submit', onClick: handleSubmit }}>{Post}</Btn>
                  <Btn attrBtn={{ color: 'light', type: 'reset', onClick: handleDiscard }}>{Discard}</Btn>
                </div>
              </CardBody>
            </Card>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default MateriPostContain;